import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-generic-image-dialog',
  templateUrl: './generic-image-dialog.component.html',
  styleUrls: ['../../../../../styles/global/_dialog-styles.scss']
})
export class GenericImageDialogComponent{

  constructor(public dialogRef: MatDialogRef<GenericImageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  onOkayClick(): void {
    this.dialogRef.close();
  }

}
